import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const SearchIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>search</title>
    <path d="M32,27.4l-.71.71-2.24-2.24a13,13,0,1,0-2.83,2.83l2.24,2.24-.71.71,10.6,10.59L42.61,38ZM12.24,24.57a9,9,0,1,1,6.36,2.63,8.93,8.93,0,0,1-6.36-2.63" />
  </IconBase>
);
